import type { ParametersGeoBoundingBox } from "@/lib/api";
import { mapRegionPresetBes, mapRegionPresetNl } from "@/config/map-region-presets";

const COORD_EPSILON = 5e-4;

function coordEqual(a: number, b: number): boolean {
  return Math.abs(Number(a) - Number(b)) < COORD_EPSILON;
}

export function viewportBoundsEqual(
  a: ParametersGeoBoundingBox | undefined,
  b: ParametersGeoBoundingBox | undefined,
): boolean {
  if (!a || !b) return false;
  return (
    coordEqual(a.north_latitude, b.north_latitude) &&
    coordEqual(a.south_latitude, b.south_latitude) &&
    coordEqual(a.east_longitude, b.east_longitude) &&
    coordEqual(a.west_longitude, b.west_longitude)
  );
}

export const initialViewportPresets = {
  nl: mapRegionPresetNl.toGeoBoundingBox(),
  bes: mapRegionPresetBes.toGeoBoundingBox(),
} as const;
